export default class HeaderAppMenu {
    /** @returns {string} */
    static getHTML() {
        return `
            <span class="header-app-menu">
                <button popovertarget="app-menu" popovertargetaction="toggle" class="app-button">Apps 
                    <span class="material-symbols-outlined dropdown-icon">arrow_drop_down</span>
                </button>
                <div popover id="app-menu" class="app-menu" popovertargetaction="show">
                    <ul class="list">
                        <li class="list-item">
                            <p>Meve</p>
                            <p class="item-description">Track what happens to your molecules</p>
                            <div class="links-row">
                                <a href="https://elsci.io/meve" class="link" target="_blank">Website</a>
                                <a href="https://meve.elsci.io/" class="link" target="_blank">Cloud</a>
                            </div>
                        </li>
                        <li class="list-item">
                            <p>Molbrett</p>
                            <p class="item-description">Draw molecules and synthetic routes</p>
                            <div class="links-row">
                                <a href="https://elsci.io/molbrett" class="link" target="_blank">Website</a>
                                <a href="https://molbrett.elsci.io/" class="link" target="_blank">Cloud</a>
                            </div>
                        </li>
                        <li class="list-item">
                            <p>Crystaline</p>
                            <p class="item-description">Design and capture crystallography</p>
                            <div class="links-row">
                                <a href="https://elsci.io/crystaline/index.html" class="link" target="_blank">Website</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </span>`
    }
}
